import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api, NODE_COLORS } from "../../services/api";
import GraphView from "../../components/GraphView";

export default function DalmiaGraph() {
  const [graph, setGraph] = useState(null);
  const [focus, setFocus] = useState("");
  const [params] = useSearchParams();

  useEffect(() => {
    const f = params.get("focus");
    if (f) { setFocus(f); api.dalmiaGraph(f).then(setGraph); }
    else api.dalmiaGraph().then(setGraph);
  }, [params]);

  const refocus = (id) => { setFocus(id); api.dalmiaGraph(id).then(setGraph); };
  const reset = () => { setFocus(""); api.dalmiaGraph().then(setGraph); };

  return (
    <div className="graph-page">
      <div className="graph-toolbar">
        <div className="graph-legend">
          {["region", "plant", "depot", "sku", "dealer", "order", "truck", "supplier", "material"].map((t) => (
            <span key={t} className="gl-item"><i style={{ background: NODE_COLORS[t] }} />{t}</span>
          ))}
        </div>
        <div className="graph-tb-actions">
          {focus && <span className="focus-chip">Focused: {focus}</span>}
          {focus && <button className="btn-ghost sm" onClick={reset}>Show full graph</button>}
        </div>
      </div>
      <div className="graph-canvas-wrap">
        {graph ? <GraphView nodes={graph.nodes} edges={graph.edges} onNodeClick={refocus} />
          : <div className="loading-page">Building Dalmia relationship graph…</div>}
      </div>
      <div className="graph-hint">Dalmia enterprise map — regions hold plants and depots, plants produce SKUs and consume raw material, suppliers feed fuel/inputs, dealers place orders fulfilled by plants. Click any node to traverse its neighbourhood.</div>
    </div>
  );
}
